import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "@/context/Providers";

const inject = (id, html, src) => {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.async = true;
  if (src) s.src = src;
  else s.text = html;
  document.head.appendChild(s);
};

export const Analytics = () => {
  const site = useSite();
  const loc = useLocation();
  const a = site?.analytics;

  useEffect(() => {
    if (!a) return;
    if (a.ga4_id) {
      inject("ga4-src", null, `https://www.googletagmanager.com/gtag/js?id=${a.ga4_id}`);
      inject("ga4-init", `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${a.ga4_id}',{send_page_view:false});`);
    }
    if (a.gtm_id) inject("gtm-init", `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${a.gtm_id}');`);
    if (a.meta_pixel_id) inject("meta-pixel", `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${a.meta_pixel_id}');`);
  }, [a]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (a?.ga4_id && window.gtag) window.gtag("event", "page_view", { page_path: loc.pathname + loc.search });
    if (a?.meta_pixel_id && window.fbq) window.fbq("track", "PageView");
  }, [loc.pathname, loc.search, a]);

  return a?.gsc_verification ? <meta name="google-site-verification" content={a.gsc_verification} /> : null;
};
